import {Component, Inject, OnInit} from '@angular/core';
import {AboutApiService} from '../../services/api/general/about-api.service';
import {DIALOG_CONFIG} from 'ac-infra';

@Component({
  selector: 'about-dialog',
  templateUrl: './about-dialog.component.html',
  styleUrls: ['./about-dialog.component.scss']
})
export class AboutDialogComponent implements OnInit {

  productVersion;
  date;

  constructor(@Inject(DIALOG_CONFIG) private dialogConfig) {
    this.productVersion = dialogConfig.dialogData.productVersion;
  }

  ngOnInit(): void {
    this.date = new Date();

  }

}
